import React from 'react';
import Dropdown from '../../../../uiToolkit/Inputs/Dropdown';
import Button from '../../../../uiToolkit/Buttons/Button';
import {LLM_PROVIDER_OPTIONS} from '../../../../forms/OrgDataForm/options';
import {orgDataFormText} from '../../../../forms/OrgDataForm/orgDataFormText';
import {DashboardData} from '../../../../data/models/Workspace/Dashboard';
import {settingsText} from '../../settingsText';
import AiCreditsCard from '../components/AiCreditsCard';
import '../../settingsCards.css';
import styles from './AiSettingsUI.module.css';

interface Props {
  llmProvider: string;
  setLlmProvider: (provider: string) => void;
  onSave: () => void;
  isLoading: boolean;
  canSave: boolean;
  dashboard?: DashboardData;
  onBuyAddons: () => void;
  disabled: boolean;
}

const AiSettingsUI = React.memo(
  ({
    llmProvider,
    setLlmProvider,
    onSave,
    isLoading,
    canSave,
    dashboard,
    onBuyAddons,
    disabled,
  }: Props) => (
    <div className={`SettingsCards ${styles.container}`}>
      <p className={styles.fieldTitle}>{orgDataFormText.selectLLMProvider}</p>
      <Dropdown
        options={LLM_PROVIDER_OPTIONS}
        selectedOption={llmProvider}
        setSelectedOption={setLlmProvider}
        placeholder={orgDataFormText.llmProviderPlaceholder}
      />
      <div className={styles.actions}>
        <Button
          title={settingsText.save}
          onClick={onSave}
          isLoading={isLoading}
          disabled={!canSave}
        />
      </div>
      <div className="CardsRow">
        <AiCreditsCard
          onBuyAddons={onBuyAddons}
          creditsAvailable={dashboard?.aiCreditsAvailable ?? 0}
          disabled={disabled}
        />
      </div>
    </div>
  ),
);

export default AiSettingsUI;
